"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResizeObserver = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
/**
 * @description  A React hook for observing any element resize.
 * @param target
 * @param callback
 * @returns {*}
 */
var useResizeObserver = exports.useResizeObserver = function useResizeObserver(_ref) {
  var target = _ref.target,
    callback = _ref.callback;
  var _useState = (0, _react.useState)({
      bottom: 0,
      height: 0,
      left: 0,
      right: 0,
      top: 0,
      width: 0,
      x: 0,
      y: 0
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  (0, _react.useEffect)(function () {
    if (target.current) {
      var observer = new ResizeObserver(function (_ref2) {
        var _ref3 = (0, _slicedToArray2["default"])(_ref2, 1),
          entry = _ref3[0];
        setState(entry.contentRect);
        callback && callback(entry.contentRect);
      });
      observer.observe(target.current);
      return function () {
        observer.disconnect();
      };
    }
  }, [target]);
  return state;
};